import React from "react";
import "./Footer.css";
import {
  FaInstagram,
  FaLinkedin,
  FaFacebook,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
} from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="app-footer">
      <div className="app-footer-container">
        <div className="app-footer-col">
          <h3>AAPS Placements</h3>
          <p>
            Industry-focused training with real-time projects and strong
            placement support.
          </p>
        </div>

        <div className="app-footer-col">
          <h4>Quick Links</h4>
          <ul>
            <li>Home</li>
            <li>About</li>
            <li>Courses</li>
            <li>Contact</li>
            <li>Trainings</li>
          </ul>
        </div>

        <div className="app-footer-col">
          <h4>Courses</h4>
          <ul>
            <li>Java Full Stack</li>
            <li>Python Full Stack</li>
            <li>Data Analyst</li>
            <li>AI & ML</li>
            <li>Data Engineer</li>
          </ul>
        </div>

        <div className="app-footer-col">
          <h4>Contact</h4>

          <p className="contact-item">
            <FaMapMarkerAlt /> Andhra Pradesh
          </p>

          <p className="contact-item">
            <FaPhoneAlt />
            <a href="tel:+919876543210">+91 9573470659</a>
          </p>

          <p className="contact-item">
            <FaEnvelope />
            <a href="mailto:hr@aapsplacements.in">hr@aapsplacements.in</a>
          </p>

          <div className="app-social-icons">
            <a
              href="https://www.instagram.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram />
            </a>

            <a
              href="https://www.linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedin />
            </a>

            <a
              href="https://www.facebook.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebook />
            </a>
          </div>
        </div>
      </div>

      <div className="app-footer-bottom">
        <p>© 2026 AAPS Placements. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
